// ✅ src/axiosConfig.js
import axios from 'axios';

const api = axios.create({
  baseURL: '/api', // change to 'http://localhost:5000/api' if proxy not set
  withCredentials: true
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default api;